var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9774 9.08502L14.5653 2.98907C13.3682 2.00707 11.6333 2.00607 10.4363 2.98907L3.02436 9.08404C2.70536 9.34704 2.65833 9.81907 2.92133 10.1401C3.18433 10.4611 3.65736 10.5051 3.97736 10.2431L4.75031 9.60711V18.0001C4.75031 20.4181 6.08231 21.7501 8.50031 21.7501H16.5003C18.9183 21.7501 20.2503 20.4181 20.2503 18.0001V9.60711L21.0233 10.2431C21.1633 10.3581 21.3323 10.414 21.5003 10.414C21.7163 10.414 21.9313 10.321 22.0793 10.141C22.3433 9.82005 22.2964 9.34802 21.9774 9.08502ZM14.2503 20.2501H10.7503V16.5001C10.7503 15.5351 11.5353 14.7501 12.5003 14.7501C13.4653 14.7501 14.2503 15.5351 14.2503 16.5001V20.2501ZM18.7503 18.0001C18.7503 19.5771 18.0773 20.2501 16.5003 20.2501H15.7503V16.5001C15.7503 14.7081 14.2923 13.2501 12.5003 13.2501C10.7083 13.2501 9.25031 14.7081 9.25031 16.5001V20.2501H8.50031C6.92331 20.2501 6.25031 19.5771 6.25031 18.0001V8.37408L11.3893 4.14911C12.0323 3.62011 12.9694 3.62011 13.6124 4.14911L18.7513 8.37506V18.0001H18.7503Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.579c92af0c60e6595128dbf30b065f6e.svg";
export { ForwardRef as ReactComponent };